import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { FooterTypeEnum } from '../../core/enums/generated/FooterTypeEnum';

@Injectable({ providedIn: 'root' })
export class FooterService {
    httpClient = inject(HttpClient);
    getFooterItem(footerType: FooterTypeEnum) { return this.httpClient.get(`api/Admin/Footer/GetFooterDetails?footerType=${footerType}`); }
}